Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDotValueRanges = exports.parseDeclarationRanges = exports.parseRefSugarCallRanges = exports.parseRefSugarDeclarationRanges = void 0;
const vue = require("@volar/vue-language-core");
function parseRefSugarDeclarationRanges(ts, ast, collectKeys) {
    const calls = [];
    ast.forEachChild(node => {
        visitNode(node);
    });
    return calls;
    function _getStartEnd(node) {
        return vue.getStartEnd(node, ast);
    }
    function visitNode(node) {
        if (ts.isVariableDeclarationList(node) && node.declarations.length === 1) {
            const declaration = node.declarations[0];
            const left = declaration.name;
            const right = declaration.initializer;
            if (right
                && ts.isCallExpression(right)
                && ts.isIdentifier(right.expression)) {
                const callText = right.expression.getText(ast);
                if (collectKeys.some(key => key === callText)) {
                    const flagStart = _getStartEnd(node).start;
                    const flag = {
                        start: flagStart,
                        end: flagStart + (node.flags === ts.NodeFlags.Const ? 'count'.length : 'let'.length),
                    };
                    const bindings = vue.findBindingVars(ts, left, ast);
                    const fnRange = _getStartEnd(right.expression);
                    calls.push({
                        flag,
                        leftBindings: bindings,
                        rightFn: fnRange,
                    });
                }
            }
        }
        node.forEachChild(child => visitNode(child));
    }
}
exports.parseRefSugarDeclarationRanges = parseRefSugarDeclarationRanges;
function parseRefSugarCallRanges(ts, ast, collectKeys) {
    const calls = [];
    ast.forEachChild(node => {
        visitNode(node);
    });
    return calls;
    function _getStartEnd(node) {
        return vue.getStartEnd(node, ast);
    }
    function visitNode(node) {
        if (ts.isCallExpression(node)
            && ts.isIdentifier(node.expression)
            && node.arguments.length) {
            const callText = node.expression.getText(ast);
            if (collectKeys.some(key => key === callText)) {
                const firstArg = node.arguments[0];
                const lastArg = node.arguments[node.arguments.length - 1];
                calls.push({
                    fullRange: _getStartEnd(node),
                    argsRange: {
                        start: firstArg.getStart(ast),
                        end: lastArg.getEnd(),
                    },
                });
            }
        }
        node.forEachChild(child => visitNode(child));
    }
}
exports.parseRefSugarCallRanges = parseRefSugarCallRanges;
function parseDeclarationRanges(ts, ast) {
    const declarations = [];
    ast.forEachChild(node => {
        visitNode(node);
    });
    return declarations;
    function _getStartEnd(node) {
        return vue.getStartEnd(node, ast);
    }
    function visitNode(node) {
        if (ts.isVariableDeclarationList(node) && node.declarations.length === 1) {
            const declaration = node.declarations[0];
            const left = declaration.name;
            const right = declaration.initializer;
            if (right) {
                const flagStart = _getStartEnd(node).start;
                const flag = {
                    start: flagStart,
                    end: flagStart + (node.flags === ts.NodeFlags.Const ? 'count'.length : 'let'.length),
                };
                const bindings = vue.findBindingVars(ts, left, ast);
                let rightFn;
                if (ts.isCallExpression(right) && ts.isIdentifier(right.expression)) {
                    rightFn = _getStartEnd(right.expression);
                }
                declarations.push({
                    flag,
                    leftIsIdentifier: ts.isIdentifier(left),
                    leftBindings: bindings,
                    right: _getStartEnd(right),
                    rightFn: rightFn,
                });
            }
        }
        node.forEachChild(child => visitNode(child));
    }
}
exports.parseDeclarationRanges = parseDeclarationRanges;
function parseDotValueRanges(ts, ast) {
    const dotValues = [];
    ast.forEachChild(node => {
        visitNode(node);
    });
    return dotValues;
    function _getStartEnd(node) {
        return vue.getStartEnd(node, ast);
    }
    function visitNode(node) {
        if (ts.isPropertyAccessExpression(node)
            && ts.isIdentifier(node.name)) {
            const text = node.name.getText(ast);
            if (text === 'value') {
                dotValues.push({
                    range: _getStartEnd(node.name),
                    beforeDot: node.expression.getEnd(),
                });
            }
        }
        node.forEachChild(child => visitNode(child));
    }
}
exports.parseDotValueRanges = parseDotValueRanges;
//# sourceMappingURL=refSugarRanges.js.map